export default __webpack_public_path__ + "static/media/add_a_photo-24px.a1583960.svg";